<section class="dev-nav">
  <div id="wrap">
    <p-button label="🏠" [raised]="true" severity="secondary" routerLink="/" />
    <p-button label="GodMode" [raised]="true" severity="secondary" routerLink="/godmode" />
    <p-button
      label="TV"
      [raised]="true"
      severity="secondary"
      routerLink="/tv" />
    <p-button
      label="Search"
      [raised]="true"
      severity="secondary"
      routerLink="/search" />
    <p-button
      label="DJ"
      [raised]="true"
      severity="secondary"
      routerLink="/jam" />
    <p-button
      label="Dev"
      [raised]="true"
      severity="secondary"
      routerLink="/dev" />
    <p-button
      label="Login"
      [raised]="true"
      severity="secondary"
      routerLink="/nickname" />
    <p-button
      label="LogOff"
      [raised]="true"
      severity="secondary"
      (click)="logOut()" />

  </div>
</section>
